/* src/app/dashboard/ui/components/toolbar/download-button/download-button.component.scss */
.download-button-wrapper {
  position: relative;
  margin-top: -5px;
}
.download-button-wrapper p {
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: 0px;
}
.download-button-wrapper .download-button {
  border: none;
  border-radius: 4px;
  margin-right: 32px;
  padding: 3px 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.1s ease;
}
.download-button-wrapper .download-button:hover {
  background: #ccc;
  transform: translateY(1px);
}
.download-button-wrapper .download-button:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transform: translateY(0);
}
.download-button-wrapper .download-button:focus {
  outline: 2px solid rgba(66, 133, 244, 0.4);
  outline-offset: 2px;
}
.download-button-wrapper .download-button:disabled {
  background-color: #c5d3ea;
  cursor: not-allowed;
  opacity: 0.7;
}
/*# sourceMappingURL=download-button.component-3CEWFIQP.css.map */
